// Chart color palette for the Analysis Workbench — values mirror the app-wide
// design tokens in `src/styles/variables.css`. Hardcoded here (not read via
// var()) because canvas-based chart libs (Chart.js/Plotly) need resolved
// color strings, not CSS custom properties.
//
// Assigned by JOB, not by chart: categorical = identity (fixed order, never
// cycled per-filter), sequential = one hue for magnitude, diverging = two
// hues + neutral mid for polarity (e.g. signed regression coefficients),
// status = reserved good/warning/critical, never reused for series.

// Fixed-order categorical theme (identity — e.g. cluster membership).
export const CATEGORICAL = [
  "#2980b9", // blue-500 (brand)
  "#0d9488", // teal-600
  "#d97706", // amber-600
  "#7c3aed", // violet-600
  "#e85528", // coral-600
  "#4a7a35", // sage-600
  "#db2777", // pink-600
  "#52525b", // zinc-600
];

// Single-hue sequential ramp (magnitude — light to dark).
export const SEQUENTIAL = ["#eaf4fa", "#9acbe9", "#4aa2d9", "#2980b9", "#1a5982"];

// Diverging pair for signed/bipolar quantities (standardized betas, odds
// ratios relative to 1.0, correlation sign) — warm negative, cool positive,
// neutral gray at the zero midpoint.
export const DIVERGING = {
  negative: "#dc2626", // red-600
  positive: "#2980b9", // blue-500
  neutral: "#e5e7eb",  // gray-200
};

// Reserved status colors — never reused for "series N".
export const STATUS = {
  good: "#16a34a",    // green-600 — technique ready / significant
  warning: "#d97706", // amber-600
  critical: "#dc2626",// red-600
  neutral: "#9ca3af", // gray-400 — not available / not run
};

export function divergingColor(value) {
  return value < 0 ? DIVERGING.negative : DIVERGING.positive;
}

export function categoricalColor(index) {
  return CATEGORICAL[index % CATEGORICAL.length];
}
